// Iter 88q — Shared resume-status metadata. Extracted from JobBoard.jsx so
// the new ResumesTable component (and any future consumer) can render the
// same pill / dropdown styling without duplicating the map.
import { Inbox, MailOpen, Sparkles, Archive, X } from "lucide-react";

export const RESUME_STATUS = [
  { key: "new",         label: "New",         icon: Inbox,    className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { key: "reviewed",    label: "Reviewed",    icon: MailOpen, className: "bg-slate-100 text-slate-700 border-slate-200" },
  { key: "shortlisted", label: "Shortlisted", icon: Sparkles, className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { key: "parked",      label: "Parked",      icon: Archive,  className: "bg-amber-50 text-amber-700 border-amber-200" },
  { key: "rejected",    label: "Rejected",    icon: X,        className: "bg-rose-50 text-rose-700 border-rose-200" },
];

export const statusMeta = (k) => RESUME_STATUS.find((s) => s.key === k) || RESUME_STATUS[0];
